module.exports = __webpack_public_path__ + "static/media/gandalf_g.6778348a.gif";